import { Box } from "@chakra-ui/react";
import React from "react";

import { MultichainProvider } from "lib/contexts/multichain";
import { apos } from "toolkit/utils/htmlEntities";
import AddressCsvExportLink from "ui/address/AddressCsvExportLink";
import AddressTxsFilter from "ui/address/AddressTxsFilter";
import useAddressInternalTxsQuery from "ui/address/useAddressInternalTxsQuery";
import InternalTxsList from "ui/internalTxs/InternalTxsList";
import InternalTxsTable from "ui/internalTxs/InternalTxsTable";
import ActionBar from "ui/shared/ActionBar";
import DataListDisplay from "ui/shared/DataListDisplay";
import ChainSelect from "ui/shared/multichain/ChainSelect";
import Pagination from "ui/shared/pagination/Pagination";

const OpSuperchainAddressInternalTxs = () => {
  const { hash, query, filterValue, onFilterChange } =
    useAddressInternalTxsQuery({ enabled: true, isMultichain: true });
  const { data, isPlaceholderData, isError, pagination } = query;

  const content = data?.items ? (
    <MultichainProvider chainSlug={query.chainValue?.[0]}>
      <Box hideFrom="lg">
        <InternalTxsList
          data={data.items}
          currentAddress={hash}
          isLoading={isPlaceholderData}
        />
      </Box>
      <Box hideBelow="lg">
        <InternalTxsTable
          data={data.items}
          currentAddress={hash}
          isLoading={isPlaceholderData}
        />
      </Box>
    </MultichainProvider>
  ) : null;

  const actionBar = (
    <ActionBar mt={-6} justifyContent="left" px={{ base: 4, lg: 6 }}>
      <AddressTxsFilter
        initialValue={filterValue}
        onFilterChange={onFilterChange}
        hasActiveFilter={Boolean(filterValue)}
        isLoading={pagination.isLoading}
      />
      <ChainSelect
        loading={pagination.isLoading}
        value={query.chainValue}
        onValueChange={query.onChainValueChange}
        ml={2}
      />
      <AddressCsvExportLink
        address={hash}
        isLoading={pagination.isLoading}
        params={{
          type: "internal-transactions",
          filterType: "address",
          filterValue,
        }}
        ml={{ base: 2, lg: "auto" }}
      />
      <Pagination ml={{ base: "auto", lg: 8 }} {...pagination} />
    </ActionBar>
  );

  return (
    <DataListDisplay
      isError={isError}
      itemsNum={data?.items.length}
      filterProps={{
        emptyFilteredText: `Couldn${apos}t find any transaction that matches your query.`,
        hasActiveFilters: Boolean(filterValue),
      }}
      emptyText="There are no internal transactions for this address."
      showActionBarIfEmpty
      showActionBarIfError
      actionBar={actionBar}
    >
      {content}
    </DataListDisplay>
  );
};

export default React.memo(OpSuperchainAddressInternalTxs);
